var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRing1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "115px",
    height: "128px",
    viewBox: "0 0 115 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-302.000000, -347.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANIMATE_intro?scale&delay=2.4-Copy-3",
    transform: "translate(294.000000, 339.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cta",
    transform: "translate(-0.000050, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "components/hexogon-cta",
    transform: "translate(0.000000, 0.000250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.4365,133.91 C62.6215,133.91 59.947,133.225 57.7015,131.9285 L17.0825,108.4775 C12.5285,105.8475 9.348,100.3385 9.348,95.0805 L9.348,48.1775 C9.348,42.919 12.5285,37.41 17.082,34.781 L57.702,11.329 C59.947,10.033 62.6215,9.348 65.4365,9.348 C68.2515,9.348 70.926,10.033 73.1705,11.329 L113.7905,34.7805 C118.3445,37.41 121.525,42.919 121.525,48.1775 L121.525,95.0805 C121.525,100.3395 118.3445,105.8485 113.79,108.4775 L73.171,131.9285 C70.926,133.225 68.2515,133.91 65.4365,133.91 Z",
    id: "ring-1"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing1);
export default __webpack_public_path__ + "static/media/ring-1.c361e892610a88f2aa529179a23074fe.svg";
export { ForwardRef as ReactComponent };